module.exports = __webpack_public_path__ + "img/core-vaccinated-logo-msd.a504e374.png";